import { render, staticRenderFns } from "./historique-wallet.vue?vue&type=template&id=0719bc5a"
import script from "./historique-wallet.vue?vue&type=script&lang=js"
export * from "./historique-wallet.vue?vue&type=script&lang=js"
import style0 from "./historique-wallet.vue?vue&type=style&index=0&id=0719bc5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports